import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { isEmpty } from 'ramda';

const Card = (props) => {
  const { title, content, tooltipContent } = props;

  return (
    <div className={cn('card', { tooltip: !isEmpty(tooltipContent) })}>
      <div className="card-title">{title}</div>
      <div className="card-content">{content}</div>
      {!isEmpty(tooltipContent) && (
        <div className="tooltip-content">{tooltipContent}</div>
      )}
    </div>
  );
};

export default Card;

Card.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tooltipContent: PropTypes.string,
};

Card.defaultProps = {
  tooltipContent: '',
};
